import styled from 'styled-components';
import {
  ClientOnlyModal,
  ModalProps,
} from '@pass-frontend/common/components/modal/ui';
import { useIntl } from '@pass-frontend/common/i18n';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

export interface MemberCodeNotFoundModalProps {
  onRequestedClose: ModalProps['onRequestedClose'];
  isOpen: ModalProps['isOpen'];
}

const StyledMemberNotFoundModal = styled(ClientOnlyModal)`
  border-radius: 17px;

  &.modal {
    width: calc(100% - 32px);
    height: auto;
    margin: 16px;
    padding-bottom: 16px;

    ${MEDIA_QUERY.desktop} {
      width: 600px;
      padding: 40px;
    }
  }

  .body {
    margin: 24px 0 0 0;
  }

  .close-btn {
    border: none;
    color: #222222;
    margin-bottom: 24px;

    .system-close {
      height: 14px;
      width: 14px;
    }
  }
`;

const ModalBody = styled.div`
  margin-bottom: 40px;

  .modal-body-one {
    margin-bottom: 16px;
  }
`;

const ModalTitle = styled.h1.attrs({
  className: 'is-display-flex is-h3 has-text-blue-1',
})`
  margin: 24px 0;
`;

const GotItButton = styled.div.attrs({
  className: 'is-display-flex is-justify-content-end',
})`
  button {
    ${MEDIA_QUERY.mobileAndTablet} {
      width: 100%;
      height: 32px;
      padding: 6px 0;
    }
  }

  &:hover {
    text-decoration: none;
  }
`;

export function MemberCodeNotFoundModal(props: MemberCodeNotFoundModalProps) {
  const { t } = useIntl();
  return (
    <StyledMemberNotFoundModal
      className="modal"
      data-testid="member-code-not-found-modal"
      ariaHeadingId="member-code-not-found-modal"
      ariaLabel={t('memberCodeNotFoundModal.title')}
      shouldHideHeading={true}
      overlayZIndex={1001}
      {...props}
    >
      <>
        <ModalTitle>{t('memberCodeNotFoundModal.title')}</ModalTitle>
        <ModalBody className="is-body-2-regular has-text-primary">
          <div className="modal-body-one">
            {t('memberCodeNotFoundModal.bodyOne')}
          </div>
          <div>
            {t('memberCodeNotFoundModal.bodyTwo', {
              phoneNumber: (
                <span className="is-body-2-bold">
                  {t('memberCodeNotFoundModal.phoneNumber')}
                </span>
              ),
            })}
          </div>
        </ModalBody>
        <GotItButton>
          <button
            type="button"
            className="btn btn-primary"
            onClick={props.onRequestedClose}
          >
            {t('memberCodeNotFoundModal.gotItButton')}
          </button>
        </GotItButton>
      </>
    </StyledMemberNotFoundModal>
  );
}
